<script setup>
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useResultsStore } from '../stores/results-fetcher.js'
import { useStateStore } from '../stores/state.js'

const resultsStore = useResultsStore()
const stateStore = useStateStore()
const router = useRouter()
const route = useRoute()

const currentEventAlias = computed(() => route.params.eventAlias)

const relatedEvents = computed(() => {
  const currentEvent = resultsStore.event
  if (!currentEvent || !currentEvent.competition_id) return []
  return stateStore.events.filter(e => e.competition_id === currentEvent.competition_id)
})

const hasMultipleEvents = computed(() => relatedEvents.value.length > 1)

const currentEventName = computed(() => {
  if (resultsStore.event && resultsStore.event.name) return resultsStore.event.name
  return currentEventAlias.value
})

function switchToEvent(eventAlias) {
  if (eventAlias === currentEventAlias.value) return
  router.push({ name: route.name, params: { eventAlias } })
}
</script>

<template>
  <div v-if="hasMultipleEvents" class="event-switcher mb-2">
    <div class="dropdown">
      <button
        class="btn btn-outline-secondary btn-sm dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="Przełącz pomiędzy edycjami wydarzenia"
      >
        {{ currentEventName }}
      </button>
      <ul class="dropdown-menu">
        <li v-for="event in relatedEvents" :key="event.id">
          <a
            class="dropdown-item"
            :class="{ active: event.alias === currentEventAlias }"
            href="#"
            @click.prevent="switchToEvent(event.alias)"
          >
            {{ event.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
